import FloatLabel from "./FloatLabel";
import ErrorLabel from "./ErrorLabel";
import { Textarea } from "@chakra-ui/react";
import { useController } from "react-hook-form";

export default function TextAreaControl({ control, name, label, placeholder, isDisabled = false, row,isRequired = false, rules }) {
	const {
		field: { value = "", ...field },
		fieldState: { error },
	} = useController({
		name,
		control,
		rules: { required: isRequired && `${label} is required`, ...rules },
	});

	return (
		<>
			<FloatLabel label={label} isRequired={isRequired}>
				<Textarea isDisabled={isDisabled} rows={row} value={value} {...field} placeholder={placeholder} />
				<ErrorLabel>{error?.message}</ErrorLabel>
			</FloatLabel>
		</>
	);
}
